// TOP LEVEL IMPORTS
import gql from 'graphql-tag';
import invoiceFragment from 'ApolloClient/Fragments/invoiceFragment';

export default gql`
  query invoiceById($_id: ID!) {
    invoiceById(_id: $_id) {
      ...invoiceFragment
      organization {
        _id
        title
        email
        image
        city
        state
        street1
        street2
        zip
        stripeUserIdExists
      }
      owner {
        paypalSet
        paypalEmail
      }
    }
  }
  ${invoiceFragment}
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/invoiceById.js